/**
 * @fileoverview Name a new folder or subfolder for either Documents screen. Callers own the destination and the `/documents/folders` write; this dialog only collects the name. Styles live with the firm-wide page in `DocumentsPage.css`.
 */

import React from 'react';
import AppIcon from '../shared/AppIcon';
import './DocumentsPage.css';

export default function NewFolderModal({ visible, form, submitting, error, onChange, onClose, onSubmit }) {
  if (!visible) return null;
  const isSubfolder = Boolean(form.is_subfolder);
  return (
    <div
      className="documents-vcs-modal-backdrop"
      role="presentation"
      onClick={(event) => {
        if (event.target === event.currentTarget) onClose();
      }}>
      <form
        className="documents-vcs-modal documents-new-folder-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="documents-new-folder-title"
        onSubmit={(event) => {
          event.preventDefault();
          if (!submitting && String(form.folder_name || '').trim()) onSubmit();
        }}>
        <header>
          <h2 id="documents-new-folder-title">{isSubfolder ? 'New Subfolder' : 'New Folder'}</h2>
          <button type="button" aria-label="Close new folder" onClick={onClose}><AppIcon icon="pi pi-times" /></button>
        </header>
        {isSubfolder && (
          <div className="documents-new-folder-parent" aria-label={`Parent folder ${form.parent_label || 'Current folder'}`}>
            <AppIcon icon="pi pi-folder-open" aria-hidden="true" />
            <span>
              <small>Inside</small>
              <strong>{form.parent_label || 'Current folder'}</strong>
            </span>
          </div>
        )}
        <label>
          <span>Name</span>
          <input
            autoFocus
            value={form.folder_name || ''}
            onChange={(event) => onChange({ folder_name: event.target.value })}
            placeholder={isSubfolder ? 'Motions' : 'Operations'} />
        </label>
        {error && <div className="documents-archive-error" role="alert">{error}</div>}
        <footer>
          <button type="button" className="documents-archive-link-button" onClick={onClose}>Cancel</button>
          <button
            type="submit"
            className="documents-workspace-action-button is-primary"
            disabled={submitting || !String(form.folder_name || '').trim()}>
            <AppIcon icon="pi pi-folder-plus" aria-hidden="true" />
            {submitting ? 'Creating...' : isSubfolder ? 'Create subfolder' : 'Create folder'}
          </button>
        </footer>
      </form>
    </div>
  );
}
